<template>
  <div class="page_wrapper">
    <div class="container">
    <div class="app">
      <ul class="toolbar">
        <li class="game" tabindex="1" :class="{open:menu.game}" @click="menu.game=!menu.game" @blur="menu.game=false">
          <span>Game</span>
          <div class="cancel" />
          <div class="menu">
            <ul>
              <li v-for="item of levels" :key="item.name" :class="{checked:level===item}" @click="changeLevel(item)">
                <span class="check">✔</span> {{ item.name }}
              </li>
              <hr>
              <li :class="{checked:qmark}" @click="qmark=!qmark">
                <span class="check">✔</span> Marks(?)
              </li>
            </ul>
          </div>
        </li>
        <li class="help"><span class="help">Help</span></li>
      </ul>
      <minesweeper :level="level" :qmark="qmark" />
    </div>
  </div>
  </div>
</template>
<script>
import Minesweeper from '../Minesweeper/Minesweeper.vue'
export default {
  name: 'App',
  components: { Minesweeper },
  data () {
    return {
      levels: [
        { name: 'Beginner', size: [9, 9], mineTotal: 10 },
        { name: 'Intermediate', size: [16, 16], mineTotal: 40 },
        { name: 'Expert', size: [16, 30], mineTotal: 99 }
      ],
      qmark: false,
      level: { name: 'Beginner', size: [9, 9], mineTotal: 10 },
      menu: { game: false }
    }
  },
  computed: {
    isMenuOpen () { return !Object.values(this.menu).every(x => !x) }
  },
  watch: {
    isMenuOpen (v) { this.$emit('menu', v) }
  },
  methods: {
    changeLevel (item) {
      this.level = item
      this.$emit('changeLevel', item)
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Bungee+Shade");
.logo {
  margin: 1% 0 0 0;
  height: 10vh;
  padding: 5px;
  background: white;
  border-radius: 5px;
  box-shadow: 2px 2px 10px black;
}
a {
  text-decoration: none;
}

h1 {
  margin: 0 0 0 0;
  color: rgb(34, 34, 32);
  font-weight: 400;
  font-family: "Bungee Shade", cursive;
  font-size: 3vw;
  text-shadow: 3px 2px 4px rgba(0, 0, 0, 0.548);
}
.page_wrapper {
  text-align: center;
  background-image: url('../assets/images/background.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  overflow: hidden;
}
.menu_wrapper {
  /* margin: 0; */
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.option img {
  transition: all 0.3s;
  margin: 5% 5% -2% 5%;
  width: 19vw;
  padding: 5%;
  border: 2px solid lightblue;
  border-radius: 10px;
  height: 12vw;
}
.option p {
  color: lightsalmon;
  text-align: center;
  font: 3vw Georgia, Times New Roman, serif;
}

.option {
  position: relative;
  top: 10vh;
  background: rgb(34, 34, 32);
  border-radius: 10px;
  width: 25vw;
  height: 25vw;
  -webkit-box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
  padding: 4%;
}
.box {
  margin: 0 auto;
  background: rgb(200, 200, 200);
  border-radius: 10px;
  width: 75%;
  -webkit-box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);
  text-align: center;
  padding: 1% 2% 4%;
  opacity: 0.75;
}
.larger {
  transform: scale(1.1, 1.1);
}

.option:hover {
  transition: all 0.3s;
  transform: scale(1.2, 1.2);
  border: 3px solid firebrick;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.8);
}
.option:hover p {
  color: red;
}

.option:hover img {
  padding: 2%;
  border: 5px solid lightblue;
  border-radius: 10px;
}

@media screen and (max-width: 400px) {
  h1 {
    font-size: 20px;
  }
  .option img {
    height: 7vh;
  }
  .option {
    background: rgb(34, 34, 32);
    padding: 4%;
    height: 15vh;
    position: relative;
    top: 10vh;
    text-align: center;
  }
  .option p {
    margin: none;
    font-size: 10px;
    color: red;
  }
}
:focus {outline: none;}
.container {
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-family: Tahoma;
  display: flex;
  justify-content: center;
}
.app {max-width: 100%;}
ul {list-style: none;}
.toolbar {
  padding: 1px 0;
  margin: 0;
  position: relative;
  user-select: none;
  flex-direction: row;
  display: flex;
}
.toolbar > li {
  display: flex;
  cursor: default;
  position: relative;
}
.toolbar > li > span {
  display: flex;
  align-items: center;
  border: solid 1px transparent;
  padding: 0 5px;
  height: 16px;
}
.toolbar > li > span:hover:not(.help) {border: outset 1px #eee;}
.toolbar > li.open > span {border: inset 1px #eee;}
.toolbar > li.open .cancel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.toolbar > li:not(.open) > .menu {display: none;}
.menu {
  position: absolute;
  border: solid 1px silver;
  border-right-color: #000;
  border-bottom-color: #000;
  background-color: silver;
  top: 100%;
  left: 0;
}
.menu hr {
  border-style: inset;
  border-width: 1px;
  margin: 3px 1px 4px 1px;
}
.menu > ul {
  border: outset 1px #eee;
  width: 120px;
  padding: 1px;
}
.menu > ul > li {padding: 4px 6px;}
.menu > ul > li.checked > .check {visibility: visible;}
.menu > ul > li > .check {visibility: hidden;}
.menu > ul > li:hover {
  color: white;
  background-color: #0000a8;
}
.check {font-weight: bolder;}
</style>
